import React from 'react';
import { BarChart3, TrendingUp, Package, Truck, MapPin } from 'lucide-react';

const TABS = [
  { id: 'overview', label: 'Overview', icon: BarChart3 },
  { id: 'trends', label: 'Trends', icon: TrendingUp },
  { id: 'goods', label: 'By goods', icon: Package },
  { id: 'transport', label: 'By transport', icon: Truck },
  { id: 'corridors', label: 'Top routes', icon: MapPin },
];

export default function ChartTabs({ activeChart, onChange }) {
  return (
    // Scrolls sideways on narrow screens instead of wrapping into a ragged block.
    <div className="-mx-4 overflow-x-auto px-4 sm:mx-0 sm:px-0">
      <div role="tablist" aria-label="Freight charts" className="glass-control inline-flex min-w-max gap-1 rounded-full border border-border bg-muted p-1">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeChart === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              onPointerDown={() => onChange(tab.id)}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onChange(tab.id)}
              className={`flex items-center gap-2 rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors duration-150 ${
                isActive ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon className="h-4 w-4" aria-hidden="true" />
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
